const MAX_DIMENSION = 800;
const JPEG_QUALITY = 0.85;

// Redimensionne une image côté client avant l'envoi, pour garder le dataset léger.
// En cas d'échec (format non supporté, canvas indisponible…), retourne le fichier
// d'origine plutôt que de bloquer le téléversement.
export function resizeImageFile(file: File): Promise<File> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onerror = () => resolve(file);
    reader.onload = () => {
      const image = new Image();
      image.onerror = () => resolve(file);
      image.onload = () => {
        const scale = Math.min(1, MAX_DIMENSION / Math.max(image.width, image.height));
        const targetWidth = Math.round(image.width * scale);
        const targetHeight = Math.round(image.height * scale);
        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          resolve(file);
          return;
        }
        ctx.drawImage(image, 0, 0, targetWidth, targetHeight);
        canvas.toBlob(
          (blob) => resolve(blob ? new File([blob], file.name, { type: 'image/jpeg' }) : file),
          'image/jpeg',
          JPEG_QUALITY,
        );
      };
      image.src = reader.result as string;
    };
    reader.readAsDataURL(file);
  });
}
